import { Step } from "@storebrand-digital/insurance-stepper";
import { CHECKOUT_STEPS } from "Components/Features/CheckOut/checkoutSteps";
import { MainPath } from "Constants/constants";

export const AKA_TRAVEL_YOUR_PRODUCT_STEP: Step = {
  id: "din-reiseforsikring",
  title: "Din reiseforsikring",
  ariaLabel: `${MainPath.CHECK_PRICE}-din-reiseforsikring`,
  complete: false,
};

export const AKA_TRAVEL_PRICE_STEP: Step = {
  id: "product-price",
  title: "Sjekk pris",
  ariaLabel: `${MainPath.CHECK_PRICE}-product-price`,
  complete: false,
};

export const AKA_TRAVEL_STEPS: Step[] = [
  AKA_TRAVEL_YOUR_PRODUCT_STEP,
  AKA_TRAVEL_PRICE_STEP,
  ...CHECKOUT_STEPS,
];
